import { render, staticRenderFns } from "./PuntoDeVenta.vue?vue&type=template&id=e3838c22&scoped=true"
import script from "./PuntoDeVenta.vue?vue&type=script&lang=js"
export * from "./PuntoDeVenta.vue?vue&type=script&lang=js"
import style0 from "./PuntoDeVenta.vue?vue&type=style&index=0&id=e3838c22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3838c22",
  null
  
)

export default component.exports